/*
 * Copyright (c) 2026 CalAmp Corp.  All Rights Reserved
 */
import {
  useCallback,
  useMemo,
  useState
} from 'react';

export const queryChipsID     = 'query-chips';
export const CLEAR_ALL_BUTTON = 'queries-clear-all';

export const useQueryDialog = (queries: any) => {
  const [savedQueryName, setSavedQueryName]                 = useState<string>('');
  const [canShowSaveQueryDialog, setCanShowSaveQueryDialog] = useState<boolean>(false);

  const canShowQueryOperations = useMemo(() => queries?.length > 0, [queries]);

  const handleClose = useCallback(() => {
    setCanShowSaveQueryDialog(false);
    setSavedQueryName('');
  }, []);

  const onSaveClick = useCallback(() => {
    setCanShowSaveQueryDialog(true);
  }, []);

  const resetSavedQueryName = useCallback(() => {
    setSavedQueryName('');
  }, []);

  return {
    setCanShowSaveQueryDialog,
    canShowQueryOperations,
    canShowSaveQueryDialog,
    resetSavedQueryName,
    setSavedQueryName,
    savedQueryName,
    handleClose,
    onSaveClick
  };
};
